export default {
  methods: {
    /**
     * Translate the given key.
     */
    __(key, replace) {
      let translation = true

      translation = this.$page.words[key]
        ? this.$page.words[key]
        : key

      _.forEach(replace, (value, key) => {
        translation = translation.replace(':' + key, value)
      })

      return translation
    }
  },
}